import type {
  Bill,
  Deliver,
} from '@backmarket/nuxt-layer-checkout/api/cart/types'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

type NormalizableAddress = Deliver | Bill

type BouyguesAddressType =
  ApiSpecs['/mobile-plan/api/v1/customer-account/address']['POST']['body']['addressType']

/**
 * Normalize and save the address. If there is no error the user can proceed to the next step, without editing the address.
 */
export const useSaveBouyguesAddress = () => {
  const $httpFetch = useHttpFetch()

  const saveBouyguesAddress = async (
    address: NormalizableAddress,
    type: BouyguesAddressType,
  ) => {
    // TODO [B2CS-273]: Handle API validation errors
    await $httpFetch('/mobile-plan/api/v1/customer-account/address', {
      method: 'POST',
      body: {
        partner: 'BOUYGUES_TELECOM',
        addressType: type,
        country: address.country,
        firstName: address.firstName,
        lastName: address.lastName,
        addressLine1: address.street ?? '',
        addressLine2: address.street2,
        postCode: address.postalCode,
        city: address.city,
      },
    })
  }

  return { saveBouyguesAddress }
}
